var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-0 max-h-500px",staticStyle:{"overflow":"auto"}},[_vm._l((_vm.calculatedProjects),function(project,p){return [_c('ProjectItem',{key:p,attrs:{"project":project}})]}),(_vm.calculatedProjects.length == 0)?_c('div',{staticClass:"text-center py-3"},[_c('span',[_vm._v("No Projects")])]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }